'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerFilter = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var DrawerFilter = exports.DrawerFilter = function () {
  function DrawerFilter(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, DrawerFilter);

    this.el = el;
    this.context = context;

    this.setupListeners();

    var selected = '';
    var filterTitle = '';

    this.getAllButtons().forEach(function (button) {
      if (JSON.parse(button.getAttribute('aria-current'))) {
        selected = button.dataset.value;
      }
    });

    this.selectedFilter = {
      el: el,
      filterTitle: filterTitle,
      selected: selected
    };
  }

  (0, _createClass3.default)(DrawerFilter, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();
      this.listeners.add(this.el, 'click', this.handleButtonClick.bind(this));
    }
  }, {
    key: 'handleButtonClick',
    value: function handleButtonClick(_ref2) {
      var target = _ref2.target;

      if (!this.hasButton(target)) return;

      var targetButton = this.getButton(target);

      /* Return user to top of page, regardless of position when filtering */
      window.scrollTo(0, 0);

      this.getAllButtons().forEach(function (button) {
        if (targetButton.dataset.value === button.dataset.value) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.setAttribute('aria-current', 'false');
        }
      });

      this.selectedFilter.selected = targetButton.dataset.value;
      this.selectedFilter.filterTitle = targetButton.dataset.title;

      var tags = [this.selectedFilter.selected];
      var title = [this.selectedFilter.filterTitle];

      this.dispatchEvent(tags, title);

      this.closeDrawer();
    }
  }, {
    key: 'closeDrawer',
    value: function closeDrawer() {
      window.drawers.activeDrawerKey = '';
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(tags, title) {
      this.el.dispatchEvent(new CustomEvent('filterChange', {
        detail: { tags: tags, title: title }
      }));
    }
  }, {
    key: 'getAllButtons',
    value: function getAllButtons() {
      return (0, _functional.getElements)(this.selectors.button, { context: this.el });
    }
  }, {
    key: 'getButton',
    value: function getButton(el) {
      return el.closest(this.selectors.button);
    }
  }, {
    key: 'hasButton',
    value: function hasButton(el) {
      return this.getButton(el) != null;
    }
  }, {
    key: 'selectors',
    get: function get() {
      return {
        button: '.' + this.context.className + '_Button'
      };
    }
  }]);
  return DrawerFilter;
}();